import { cloneDeep } from 'lodash-es';

interface Params {
  canBeUndefined?: string[];
}

export function useFilterUtils<ApiFormType = any>(params: Params) {
  const canBeUndefined = params?.canBeUndefined || null;

  const customToApi = (form: any)  => {
    if (!canBeUndefined) {
      return form;
    }

    const result = cloneDeep(form);
    canBeUndefined.forEach((key) => {
      if (result[key] === 'undefined') {
        delete result[key];
      }
    });

    return result
  };

  const apiToCustom = (form: any) => {
    if (!canBeUndefined) {
      return form;
    }

    const result = cloneDeep(form);
    canBeUndefined.forEach((key) => {
      if(typeof result[key] === 'undefined') {
        result[key] = 'undefined';
      }
    });

    return result;
  };

  return { customToApi, apiToCustom };
};
